
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://juzgqtiwgwwwhuxbkzig.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp1emdxdGl3Z3d3d2h1eGJremlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0MDU1MDksImV4cCI6MjA1MTk4MTUwOX0.wQTJVqDVx7hBvJ1BnwSYrJSG_5YT4CxMF0KgFw_5Iy0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Define Bracelet interface for TypeScript
export interface Bracelet {
  id: number;
  referral_code: string;
  registered_at: string | null;
  is_donated: boolean;
  donation_type: string | null;
  nickname: string | null;
  church_code: string | null;
  registered_user_id: string | null;
  created_at: string;
  created_by_user_id: string | null;
}

// Define ChurchBranding interface for TypeScript
export interface ChurchBranding {
  church_code: string;
  church_name: string;
  logo_url: string | null;
  primary_color: string;
  secondary_color: string;
  custom_welcome_message: string | null;
}
